import { trackDemoClick } from "@/lib/telemetry";
import { Button } from "./ui/button";
import heroImage from "@/assets/hero-heart-v2.webp";
import { Media } from "./Media";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

export const Hero = () => {
  return (
    <section className="band-dark relative overflow-hidden border-b border-border">
      {/* Faint blueprint grid — the PathFree "precision" backdrop */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.5]"
        style={{
          backgroundImage:
            "linear-gradient(to right, hsl(var(--border)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--border)) 1px, transparent 1px)",
          backgroundSize: "88px 88px",
          maskImage: "radial-gradient(120% 90% at 20% 0%, black 25%, transparent 75%)",
          WebkitMaskImage: "radial-gradient(120% 90% at 20% 0%, black 25%, transparent 75%)",
        }}
        aria-hidden="true"
      />

      <div className="container mx-auto px-6 py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="reveal space-y-7">
            <div className="eyebrow eyebrow-dot">
              AI-enabled Code Blue decision support
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold">
              Expert-trained guidance
              <br />
              <span className="text-accent">for clearer codes</span>
              <br />
              &amp; better outcomes.
            </h1>
            <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
              <strong className="font-semibold text-foreground">datasyteAI™</strong> adapts to your protocols and expert
              preferences. With clinician-in-the-loop training, it surfaces the
              next step, timing cues, and documentation prompts—modeled after how
              your top performers lead a code.
            </p>
            <div className="flex gap-4 flex-wrap items-center">
              <Button asChild size="lg">
                <a href="https://pathfree.com/contact" onClick={() => trackDemoClick("hero")}>
                  Get a Live Demo
                </a>
              </Button>
              <Button asChild variant="ghost" size="lg" className="text-primary hover:text-primary">
                <a href="#videos">Watch the Explainer →</a>
              </Button>
            </div>
            <div className="hairline pt-5 max-w-xl">
              <p className="text-sm font-semibold text-foreground">Regulatory status:</p>
              <p className="text-sm text-muted-foreground">
                AIMediQ™ powered by datasyteAI™ is currently in the pre-market /
                development &amp; validation phase. Not FDA cleared or approved; not
                for clinical use or sale.
              </p>
            </div>
          </div>


          <div className="reveal relative">
            <HoverCard openDelay={300} closeDelay={100}>
              <HoverCardTrigger asChild>
                <div className="media-frame relative cursor-pointer group">
                  <Media
                    src={heroImage}
                    alt="Concept visualization of a hospital Code Blue team guided by the AIMediQ™ AI Code Cart"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    sizes="(max-width: 1024px) 100vw, 660px"
                    eager
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background/90 to-transparent px-4 pt-10 pb-3">
                    <span className="font-mono text-[0.6875rem] uppercase tracking-[0.22em] text-foreground">
                      Concept visualization · Every second measured
                    </span>
                  </div>
                </div>
              </HoverCardTrigger>
              <HoverCardContent side="top" sideOffset={12} collisionPadding={16} className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">AI-Assisted Resuscitation</h4>
                  <p className="text-sm text-muted-foreground">
                    datasyteAI™ provides real-time guidance to code teams, ensuring every critical step is executed with precision and proper timing.
                  </p>
                </div>
              </HoverCardContent>
            </HoverCard>
          </div>

        </div>
      </div>
    </section>
  );
};
